export default "__VITE_ASSET__B2I2DLBO__"